let offers;
let product;
window.abModalVariant = 11;
function getCurrentlySelectedVariant(product) {
  selectedVariant = product.variants.find(
    (i) => i.id == mulberryShop.selectedVariantId
  );
  if (!selectedVariant) {
    selectedVariant = product.variants[0];
  }
  mulberryShop.selectedVariantId = selectedVariant.id;
  return selectedVariant;
}

async function mulberryPdpInit() {
  const HAS_MODAL = mulberry.core.settings.has_modal;
  const HAS_INLINE = mulberry.core.settings.has_inline || true;
  if (window.location.pathname.indexOf("/products/") === -1) {
    // buyy_btn
    return;
  }
  if (!HAS_MODAL && !HAS_INLINE) {
    return;
  }
  
  let response = await mulberryShop.getProductData(
    mulberryShop.getProductUrl()
  );
  product = response.product;
  let selectedVariant = getCurrentlySelectedVariant(product);
  offers = await mulberry.core.getWarrantyOffer({
    id: selectedVariant.id,
    title: product.title,
    price: selectedVariant.price,
    detail: product,
  });
  console.log("HAS_INLINE",HAS_INLINE)

  if (HAS_INLINE) {
    window.pdpInline = await mulberry.inline.init({
      offers: offers,
      settings: mulberry.core.settings,
      selector: ".mulberry-pdp-inline",
      onWarrantyToggle: async (warranty) => {
        mulberry.inline.isSelected = warranty.isSelected;
        if (warranty.isSelected) {
          window.selectedOffer = warranty;
        } else {
          window.selectedOffer = null;
        }
      },
    });
    if(soldOutStatus === false) {
      document.querySelector('.mulberry-pdp-inline').classList.remove('hide')
    }
  }
  if (HAS_MODAL) {
    window.pdpModal = await mulberry.modal.init({
      offers: offers,
      settings: mulberry.core.settings,
      onWarrantySelect: async (warranty) => {
        const result = await mulberryShop.getWarrantyVariant(warranty);
        await mulberryShop.addWarrantyToCart(
          result.shopify_variant_id,
          product,
          warranty
        );
        mulberry.modal.close();
      },
      onWarrantyDecline: async () => {
        mulberry.modal.close();
      },
    });
  }

  document.addEventListener(
    "variant:change",
    async function (e) {
      window.selectedOffer = null;
      window.pdpInline.deselectOffer();
      if (HAS_INLINE) {
        window.pdpInline.updateOffer([]);
      }
      if (HAS_MODAL) {
        window.pdpModal.updateOffer([]);
      }
      selectedVariant = e.detail.variant;
      offers = await mulberry.core.getWarrantyOffer({
        id: selectedVariant.id,
        title: product.title,
        price: `${(selectedVariant.price/100).toFixed(2)}`,
        detail: product,
      });

      if (HAS_INLINE) {
        window.pdpInline.updateOffer(offers);
      }
      if (HAS_MODAL) {
        window.pdpModal.updateOffer(offers);
      }
    }
  );
}

document
  ?.querySelector(".product-form--atc-button")
  ?.addEventListener("click", async function () {
    const HAS_MODAL = mulberry.core.settings.has_modal;
    const HAS_INLINE = mulberry.core.settings.has_inline || true;

    const handleClick = async () => {
      if (HAS_INLINE && window.selectedOffer) {
        await addWarranty();
      } else if (HAS_MODAL && !window.selectedOffer) {
        // window.pdpModal.open();
      }
    };

    await Promise.resolve().then(handleClick);
  });

async function addWarranty() {
  addToCartButtonClicked = true;
  if (!offers || offers.length == 0) {
    return;
  }
  try {
    let result;
    cart = await fetch("/cart.js");
    cartJson = await cart.json();
    if (window.selectedOffer) {
      result = await mulberryShop.getWarrantyVariant(
        window.selectedOffer.offer
      );
      const final = await mulberryShop.addWarrantyToCart(
        result.shopify_variant_id,
        {
          ...product,
          title: product.title,
          variantId: mulberryShop.selectedVariantId
        },
        window.selectedOffer.offer
      );
      window.pdpInline.deselectOffer();
      window.selectedOffer = null;
      loadCart();
    }
  } catch (err) {
    console.log("mulberry error: ", err);
  }
  mulberry.inline.deselectOffer();
}

document.addEventListener('mulberry-shopify:warranty-added', async (e) => {
  setTimeout(async () => {
    await removeAndSyncWarranties();
  }, 1200)
})

document.addEventListener("mulberry-shopify:loaded", async function (e) {
  window.mb_gtm_is_disabled = true
  setupFetchListeners();
  await removeAndSyncWarranties();
  if (document.location.href.includes("/products/")) {
    mulberryPdpInit();
  }
  await mulberryShop.cart.init();
  mulberryShop.cart.render();
});

document.addEventListener("fetch:cart-change", async function () {
  await removeAndSyncWarranties();
  setTimeout(async () => {
    loadCart();
  }, 1000);
});

document.addEventListener("fetch:cart-add", async function () {
  await removeAndSyncWarranties();
  setTimeout(() => {
    loadCart();
  }, 1000)
});


async function removeAndSyncWarranties() {
  console.log("this is being called");
  await fetch("/cart.js", {
    credentials: "same-origin",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  }).then(function (cart) {
    cart.json().then(function (firstCart) {
      newItems = [];
      cartItems = firstCart.items;
      for (i = 0; i < cartItems.length; i++) {
        item = cartItems[i];
        newItems.push(item);
      }
      firstCart.items = newItems;
      mulberryShop
        .removeDetachedWarranty(firstCart) // Remove Warranties First
        .then(async(newCart) => {
          mulberryShop.cart.syncQuantities(newCart).then(async(syncedCart)=>{
            setTimeout(async () => {
              await mulberryShop.cart.init();
              await mulberryShop.cart.render();
            }, 500);
          });
        });
    });
  });
}


function setupFetchListeners() {
  const { fetch: origFetch } = window;

  window.fetch = async (...args) => {
    // Extract request details
    const requestUrl = args[0];
    const options = args[1] || {};
    
    // Check if it's a request we want to intercept
    if (
      requestUrl.includes("cart/change") ||
      requestUrl.includes("cart/add") ||
      requestUrl.includes("cart/update.js?") ||
      requestUrl.includes("/wallets/checkouts")
    ) {
      // If it's a /wallets/checkouts request, modify the request body to add the side product
      if (requestUrl.includes("/wallets/checkouts")) {

        if (window.selectedOffer) {
          let result = await mulberryShop.getWarrantyVariant(
            window.selectedOffer.offer
          );
          const sideProduct = {
              variant_id: result.shopify_variant_id,
              quantity: parseInt(document.querySelector(".product-form__action-wrapper .quantity-selector__input").value)
          }
          // Parse the original body and add the side product
          const originalBody = JSON.parse(options.body || '{}');  
          originalBody.checkout.line_items.push(sideProduct);
  
          // Update the body in the fetch options
          options.body = JSON.stringify(originalBody);
        }
      }

      if (requestUrl.includes("cart/change")) {
        const fetchChangeCustomEvent = new CustomEvent("fetch:cart-change");
        setTimeout(() => {
          document.dispatchEvent(fetchChangeCustomEvent);          
        }, 1200);
      } 

      // Dispatch custom events for the corresponding actions
      const response = await origFetch(requestUrl, options);
      response
        .clone()
        .json()
        .then((body) => {
          if (requestUrl.includes("cart/add")) {
            // const fetchAddCustomEvent = new CustomEvent("fetch:cart-add");
            // document.dispatchEvent(fetchAddCustomEvent);
          } else if (requestUrl.includes("cart/update.js?")) {
            const fetchUpdateCustomEvent = new CustomEvent("fetch:cart-change");
            document.dispatchEvent(fetchUpdateCustomEvent);
          } else if (requestUrl.includes("cart.php")) {
            const fetchCartCustomEvent = new CustomEvent("fetch:cart-page");
            document.dispatchEvent(fetchCartCustomEvent);
          }
        })
        .catch((err) => console.error(err));

      return response;
    } else {
      // For other requests, proceed with the original fetch call
      return origFetch(...args);
    }
  };
}

